import RideCard from './RideCard';

export default RideCard;
